import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Input,
  Label,
  FormGroup,
  PaginationLink,
  PaginationItem,
  Pagination,
  Spinner
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import Loading from 'lib/loading'
import './style.css'
import moment from "moment"
import ReactSelect from "components/Form/Select/Select"

const FormCaixaTotalizado = ({ fechaModal, periodo, filial_id, tipo }) => {

  const [form, setForm] = useState('')
  const [loading, setLoading] = useState(true)
  const [loadingComponent, setLoadingComponent] = useState(false)
  const [listaLojas, setListaLojas] = useState([]);
  const [lojasSelecionadas, setLojasSelecionadas] = useState([]);
  const [loja_id, setLojaId] = useState([])
  const [totalPaginas, setTotalPaginas] = useState(0);
  // const [controlePaginacao, setControlePaginacao] = useState({ paginasExibir: [], totalPaginas: 0 })
  const [pagina, setPagina] = useState(1)

  useEffect(() => {
    // if(caixa_id != ''){
    listarLojas();  
    editCaixa();  
    // }else{
    //   setForm('')
    //   setLoading(false)
    // }
  }, [])

  useEffect(()=>{    
    setTotalPaginas(lojasSelecionadas.length);
  },[lojasSelecionadas]);

  useEffect(()=>{    
    if(pagina == 1){
      if(lojasSelecionadas.length > 0){
        if(lojasSelecionadas[0].id == 0){
          editCaixa();
        }else{
          editCaixa(lojasSelecionadas[pagina-1].id);
        }
      }
    }else{
      editCaixa(lojasSelecionadas[pagina-1].id)
    }
  },[pagina,lojasSelecionadas])

  const listarLojas = () => {
    let lista = [{ id: 0, title: 'TODAS AS LOJAS' }]
    // let lista = []
    const url = rotas.lojas
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != '') {
          ret.lista.map(loja=>{
            lista.push({ "id": loja.filial_id, "title": loja.fantasia })
          })
          // for (let i = 0; i < ret.lista.length; i++) {
          //   lista[i+1] = { "id": ret.lista[i].filial_id, "title": ret.lista[i].fantasia }
          // }
          setListaLojas(lista);
          setLojasSelecionadas(lista);
        }
      })
      return (true)
    } catch (err) {
      console.log('err')
    }
  }

  const editCaixa = (filial_id) => { 
    
    setLoadingComponent(true);

    const parametros = {
      dataI: periodo,
      tipo : tipo
    }

    if(filial_id){
      parametros.filial_id = filial_id;
    }

    const url = rotas.caixaTotalizado;
    const retorno = rest.post(url, parametros);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '') {
        ret.lista.vendas.map(venda => {
          venda.valor = parseFloat(venda.valor);
        })

        ret.lista.recebimentos.map(recebimento => {
          recebimento.valor = parseFloat(recebimento.valor);
        })

        let keys = [];
        let obj = {};

        ret.lista.totais.map((total) => {
          obj = total;
          keys = Object.keys(obj);

          keys.map(key => {
            obj[key] = parseFloat(obj[key]);
          })

          total = obj;
        })




        // let caixa = ret.lista[0]

        // caixa.caixa_dinheiro      = parseFloat(caixa.receb_dinheiro) + parseFloat(caixa.vendas_dinheiro)
        // caixa.caixa_dinheiro      = parseFloat(caixa.caixa_dinheiro)
        // caixa.caixa_cheque        = parseFloat(caixa.caixa_cheque)
        // caixa.caixa_cheque_pre    = parseFloat(caixa.caixa_cheque_pre)
        // caixa.caixa_cartao        = parseFloat(caixa.caixa_cartao)
        // caixa.caixa_crediario     = parseFloat(caixa.caixa_crediario)
        // caixa.caixa_parcelamento  = parseFloat(caixa.caixa_parcelamento)
        // caixa.caixa_outros        = parseFloat(caixa.caixa_outros)
        // caixa.caixa_recarga       = parseFloat(caixa.caixa_recarga)
        // caixa.caixa_suprimento    = parseFloat(caixa.caixa_suprimento)
        // caixa.caixa_sangria       = parseFloat(caixa.caixa_sangria)
        // caixa.devolucoes_vista    = parseFloat(caixa.vendas_devolucoes_vista)
        // caixa.frete               = parseFloat(caixa.frete)
        // caixa.caixa_total         = parseFloat(caixa.caixa_total)

        // caixa.vendas_dinheiro       = parseFloat(caixa.vendas_dinheiro)
        // caixa.vendas_cheque         = parseFloat(caixa.vendas_cheque)
        // caixa.vendas_cheque_pre     = parseFloat(caixa.vendas_cheque_pre)
        // caixa.vendas_cartao         = parseFloat(caixa.vendas_cartao)
        // caixa.vendas_crediario      = parseFloat(caixa.vendas_crediario)
        // caixa.vendas_parcelamento   = parseFloat(caixa.vendas_parcelamento)
        // caixa.vendas_outros         = parseFloat(caixa.vendas_outros)
        // caixa.vendas_descontos      = parseFloat(caixa.vendas_desconto)
        // caixa.vendas_subsidio       = parseFloat(caixa.vendas_subsidio)
        // caixa.vendas_pix_penseBank  = parseFloat(caixa.vendas_pix_penseBank)
        // caixa.vendas_mercadoPago    = parseFloat(caixa.vendas_mercadoPago)
        // caixa.vendas_pix            = parseFloat(caixa.vendas_pix)
        // caixa.devolucoes            = parseFloat(caixa.vendas_devolucoes)
        // caixa.total_vendas          = parseFloat(caixa.vendas_total)

        // caixa.receb_dinheiro        = parseFloat(caixa.receb_dinheiro)
        // caixa.receb_cheque          = parseFloat(caixa.receb_cheque)
        // caixa.receb_cheque_pre      = parseFloat(caixa.receb_cheque_pre)
        // caixa.receb_cartao          = parseFloat(caixa.receb_cartao)
        // caixa.receb_outros          = parseFloat(caixa.receb_outros)
        // caixa.outras_lojas          = parseFloat(caixa.receb_outras_lojas)
        // caixa.total_recebimento     = parseFloat(caixa.receb_total)
        // caixa.receb_total_geral     = parseFloat(caixa.receb_total_geral)
        // caixa.desconto_recebimento  = parseFloat(caixa.desconto_recebimento)

        // caixa.receb_pix_penseBank   = parseFloat(caixa.receb_pix_penseBank)
        // caixa.receb_mercadoPago     = parseFloat(caixa.receb_mercadoPago)
        // caixa.receb_pix             = parseFloat(caixa.receb_pix)

        // caixa.caixa_pix_penseBank   = parseFloat(caixa.caixa_pix_penseBank)
        // caixa.caixa_mercadoPago     = parseFloat(caixa.caixa_mercadoPago)

        setForm(ret.lista)
        setLoading(false);
        setLoadingComponent(false)
      }
    })
  }

  const styleCaixa = (estilo) => {
    estilo = estilo.toLowerCase();

    if ((estilo.includes('dinheiro') || (estilo.includes('cheque')))) {
      return ({ background: '#aafc96' })
    }
  }

  const onChangeLojas = (value) => {
    if(value == null){      
      setLojasSelecionadas(listaLojas);
     }else{
      setLojasSelecionadas(value);    
    }
    setPagina(1);
  }

  const nextPage = () =>{    
    if(pagina < totalPaginas){
      setPagina(pagina + 1);      
    }
  }

  const priorPage = () =>{
    if(pagina > 1){
      setPagina(pagina - 1);      
    }
  }

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading tipo='componente' />
      </ModalBody>
    )
  } else {
    return (
      <Row>

        <Col md='9' className='d-flex px-0'>
          {/* <div className="card-2"> */}
          <Col md='12'>
            {/* <span className="tag-card">lojas</span> */}
            <FormGroup className="mb-0 py-2">
              <ReactSelect
                name="lojas"
                placeholder="Selecione a Loja"
                options={listaLojas}
                // defaultValue={form.filialSelect}
                onChange={onChangeLojas}
                isMulti
              // onClick={form.filialSelect ? form.filial = form.filialSelect.id : ''}
              ></ReactSelect>

            </FormGroup>
          </Col>

          {/* <Col md='2' className='px-0'>
            <Button
              color="success"
            ><i class="fas fa-redo"></i>
            </Button>
          </Col>           */}
        </Col>

        <Col md='3'>
          <div className="card-2 mt-0">
            {/* <Col> */}
              <span className="tag-card">Data do Movimento</span>
              <div><b className="titulo-gray">{moment(periodo).format('DD/MM/YYYY')}</b></div>
            {/* </Col> */}
          </div>
        </Col>

         {/* <Col md='2' className='text-right'> */}
          {/* <div className="card-2 mt-0"> */}
          {/* <Col> */}
          {/* <Button */}
            {/* color="success" */}
          {/* ><i class="fas fa-chevron-left"></i> */}
          {/* </Button> */}
          {/* <Button */}
            {/* color="success" */}
          {/* ><i class="fas fa-chevron-right"></i> */}
          {/* </Button> */}
          {/* </Col> */}
          {/* </div>     */}
        {/* </Col>  */}

        
        <Col md='12'>
        {/* <Loading tipo={'componente'}></Loading> */}
          <div className="card-2 mt-0 d-flex py-1">
            {/* <Col className='d-flex justify-content-center'> */}
            <Col md='1' className='align-middle my-1'>
              <i className={"fas fa-chevron-left border rounded p-2 " + (pagina == 1 ? 'disabled-navigation' : 'titulo-gray')}
                onClick={priorPage}
              ></i>
            </Col>            
            <Col 
              md='10' 
              className='text-center'
              ><div className="p-2">                
                {loadingComponent && <Spinner className={'load-spinner'} style={{height:'20px',width:'20px'}}></Spinner>}
                {!loadingComponent && <b className="titulo-gray">{lojasSelecionadas.length > 0 ? lojasSelecionadas[pagina-1].title : ''}</b>}
              </div>
            </Col>
            <Col md='1' className='align-middle my-1' style={{textAlign:'end'}}>
              <i className={"fas fa-chevron-right  border rounded p-2 " + (pagina == totalPaginas ? 'disabled-navigation' : 'titulo-gray')}
                onClick={nextPage}
              ></i>
            </Col>
              {/* <span className="tag-card">Caixa/Loja</span> */}
              {/* <div><b>{'CAIXA: 54 - '}</b></div>
              <div><b>{'VITABEL MATRIZ'}</b></div> */}
            {/* </Col> */}
          </div>
        </Col>

        {/* <Col md='3'>
          <div className="card-2">
            <Col>
              <span className="tag-card">Navegar</span>
              <div className='d-flex justify-content-center'>

              </div>
            </Col>
          </div>
        </Col> */}

        <Col md='4'>
          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Caixa e loja</span>
              <span><b>{form.caixa_id}</b> - {form.fantasia}</span>
            </Col>
          </div> */}
          <div className="card-2 shadow">
            <Col>
              <span className="tag-card">Geral</span>

              {form.vendas.map((venda,idx) =>
                <Row className="mb-2" key={`row-vendas-${idx}`}>
                  <Col md='4' className="p-0 m-auto">
                    <Label>{venda.tipo_pagamento}</Label>
                  </Col>
                  <Col md='8'>
                    <Input
                      disabled
                      type="text"
                      style={styleCaixa(venda.tipo_pagamento)}
                      name="dinheiro"
                      // id    = "dinheiro"
                      value={venda.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    />
                  </Col>
                </Row>

              )}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "cheque"
                    id    = "cheque"
                    value = {form.caixa_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}


              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Recargas</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#aafc96' }}
                    name="recarga"
                    id="recarga"
                    value={form.totais[0].recargas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Suprimento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#aafc96' }}
                    name="suprimento"
                    id="suprimento"
                    value={form.totais[0].suprimento.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Sangria</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#ff7f7f' }}
                    name="sangria"
                    id="sangria"
                    value={form.totais[0].sangria.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Devoluções a Vista</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#FFD54F' }}
                    name="devolucoes_vista"
                    id="devolucoes_vista"
                    value={form.totais[0].devolucoes_vista.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Frete</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#F9F9F9' }}
                    name="frete"
                    id="frete"
                    value={form.totais[0].frete.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#aafc96' }}
                    name="caixa_total"
                    id="caixa_total"
                    value={form.vendas_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>
            </Col>
          </div>
        </Col>

        <Col md='4'>
          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Data de Abertura</span>
              {form.abertura} - {form.operador_abertura}
            </Col>
          </div> */}
          <div className="card-2 shadow">
            <Col>
              <span className="tag-card">Vendas</span>
              {form.vendas.map((venda,idx) =>
                <Row className="mb-2" key={`row-vendas-total-${idx}`}>
                  <Col md='4' className="p-0 m-auto">
                    <Label>{venda.tipo_pagamento}</Label>
                  </Col>
                  <Col md='8'>
                    <Input
                      disabled
                      type="text"
                      // style  = {styleCaixa(venda.tipo_pagamento)}                      
                      name="dinheiro"
                      // id    = "dinheiro"
                      value={venda.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    />
                  </Col>
                </Row>

              )}
              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Dinheiro</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_dinheiro"
                    id    = "vendas_dinheiro"
                    value = {form.vendas_dinheiro.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}
              {/* 
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cheque"
                    id    = "vendas_cheque"
                    value = {form.vendas_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cheque_pre"
                    id    = "vendas_cheque_pre"
                    value = {form.vendas_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cartão</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cartao"
                    id    = "vendas_cartao"
                    value = {form.vendas_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Crediário</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_crediario"
                    id    = "vendas_crediario"
                    value = {form.vendas_crediario.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}
              {/* 
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Parcelamento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_parcelamento"
                    id    = "vendas_parcelamento"
                    value = {form.vendas_parcelamento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}
              {/* 
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_outros"
                    id    = "vendas_outros"
                    value = {form.vendas_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}
              {/* 
              {form.vendas_pix_penseBank > parseFloat(0) ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>PenseBank</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_pix_penseBank"
                    id    = "vendas_pix_penseBank"
                    value = {form.vendas_pix_penseBank.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''} */}

              {/* {form.vendas_mercadoPago > parseFloat(0) ?
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>MercadoPago</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "vendas_mercadoPago"
                    id    = "vendas_mercadoPago"
                    value = {form.vendas_mercadoPago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> 
              : ''} */}

              {/* {form.vendas_pix > parseFloat(0) ?
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Pix</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "vendas_pix"
                    id    = "vendas_pix"
                    value = {form.vendas_pix.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''} */}

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Desconto</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#ff7f7f' }}
                    name="vendas_descontos"
                    id="vendas_descontos"
                    value={form.totais[0].desconto_vendas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Subsidio</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#66b2ff' }}
                    name="vendas_subsidio"
                    id="vendas_subsidio"
                    value={form.totais[0].vendas_subsidio.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Devoluções</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#FFD54F' }}
                    name="devolucoes"
                    id="devolucoes"
                    value={form.totais[0].devolucoes.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#aafc96' }}
                    name="total_vendas"
                    id="total_vendas"
                    value={form.vendas_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>
            </Col>
          </div>
        </Col>

        <Col md='4'>
          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Data de Fechamento</span>
              {form.fechamento ? form.fechamento+' - '+form.operador_fechamento: <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Aberto</span></div>}
            </Col>
          </div> */}
          <div className="card-2 shadow">
            <Col>
              <span className="tag-card">Recebimentos</span>
              {form.recebimentos.map((recebimento,idx) =>
                <Row className="mb-2" key={`row-recebimento-${idx}`}>
                  <Col md='4' className="p-0 m-auto">
                    <Label>{recebimento.tipo_pagamento}</Label>
                  </Col>
                  <Col md='8'>
                    <Input
                      disabled
                      type="text"
                      // name  = "receb_dinheiro"
                      // id    = "receb_dinheiro"
                      value={recebimento.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    />
                  </Col>
                </Row>
              )}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_cheque"
                    id    = "receb_cheque"
                    value = {form.receb_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_cheque_pre"
                    id    = "receb_cheque_pre"
                    value = {form.receb_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cartão</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_cartao"
                    id    = "receb_cartao"
                    value = {form.receb_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}

              {/* <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_outros"
                    id    = "receb_outros"
                    value = {form.receb_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> */}


              {/* {form.receb_pix_penseBank > parseFloat(0) ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>PenseBank</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_pix_penseBank"
                    id    = "receb_pix_penseBank"
                    value = {form.receb_pix_penseBank.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''} */}

              {/* {form.receb_mercadoPago > parseFloat(0) ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>MercadoPago</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_mercadoPago"
                    id    = "receb_mercadoPago"
                    value = {form.receb_mercadoPago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''} */}

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Desconto</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#ff7f7f' }}
                    name="desconto_recebimento"
                    id="desconto_recebimento"
                    value={form.totais[0].desconto_recebimento.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Subtotal</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#aafc96' }}
                    name="total_recebimento"
                    id="total_recebimento"
                    value={form.receb_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outras Lojas</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#FFD54F' }}
                    name="outras_lojas"
                    id="outras_lojas"
                    value={form.totais[0].outras_lojas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type="text"
                    style={{ background: '#aafc96' }}
                    name="receb_total_geral"
                    id="receb_total_geral"
                    value={parseFloat(form.receb_total - form.totais[0].outras_lojas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  />
                </Col>
              </Row>
            </Col>
          </div>

          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Número do caixa</span>
              <span>{form.caixa_id}</span>
            </Col>
          </div> */}
          {/* 
          <div className="card-2">
            <Col>
              <span className="tag-card">Loja</span>
              <span>{form.fantasia}</span>
            </Col>
          </div>

          <div className="card-2">
            <Col>
              <span className="tag-card">Data de Abertura</span>
              {form.abertura} - {form.operador_abertura}
              
            </Col>
          </div>

          <div className="card-2">
            <Col>
              <span className="tag-card">Data de Fechamento</span>
              {form.fechamento ? form.fechamento+' - '+form.operador_fechamento: ''}
            </Col>
          </div> */}

        </Col>
        <Col className="text-center p-3">
          <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
        </Col>
      </Row>
    )
  }

}


export default FormCaixaTotalizado
